// extracted by mini-css-extract-plugin
module.exports = {"pintxo-thumbnail":"Thumbnail_pintxo-thumbnail__0SO4k"};